var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRegionChina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 481,
    height: 481,
    viewBox: "0 0 481 481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.405 .227)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 240,
    fill: "#CE0C15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0",
    fillRule: "nonzero",
    points: "85.595 0 138.496 162.812 0 62.188 171.19 62.188 32.694 162.812",
    transform: "translate(40 99.773)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0",
    fillRule: "nonzero",
    points: "28.532 0 46.165 54.271 0 20.729 57.063 20.729 10.898 54.271",
    transform: "rotate(23.036 -19.131 671.083)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0",
    fillRule: "nonzero",
    points: "28.532 0 46.165 54.271 0 20.729 57.063 20.729 10.898 54.271",
    transform: "rotate(45.87 28.717 457.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0",
    fillRule: "nonzero",
    points: "28.532 0 46.165 54.271 0 20.729 57.063 20.729 10.898 54.271",
    transform: "rotate(69.945 24.97 359.375)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0",
    fillRule: "nonzero",
    points: "28.532 0 46.165 54.271 0 20.729 57.063 20.729 10.898 54.271",
    transform: "rotate(20.66 -615.404 847.626)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegionChina);
export default __webpack_public_path__ + "static/media/ic-region-china.2ce877055e316db966f7bdb614f46ce4.svg";
export { ForwardRef as ReactComponent };